
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.672 11H.766v-.367L1.5 9.258h4.852c.114-.464.205-.987.273-1.57.068-.584.102-1.167.102-1.75 0-.438-.019-.81-.055-1.118a3.86 3.86 0 00-.164-.789 1.863 1.863 0 00-.242-.5.973.973 0 00-.274-.273 1.168 1.168 0 00-.406-.149 4.277 4.277 0 00-.797-.054H2.688c-.438 0-.79-.112-1.055-.336-.266-.224-.399-.529-.399-.914 0-.495.102-.946.305-1.352h.469c.031.255.12.45.265.586.151.13.38.195.688.195h1.773c.6 0 1.029.021 1.29.063.26.042.473.107.64.195.172.084.33.203.477.36.15.15.27.351.359.601.094.25.164.56.21.93.053.37.08.791.08 1.265v.602c0 .583-.066 1.253-.196 2.008-.13.75-.292 1.416-.485 2h1.297v.36L7.672 11z","fill":"currentColor"}})])
          )
        }
      }
    